import { connect } from 'react-redux';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { NormalizedStore } from '@store/entity/entity.types';
import { Rooms } from './Rooms';

const mapDispatchToProps = {
  changeJourneyParam,
};

const mapStateToProps = (state: NormalizedStore) => {
  return {
    journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  };
};

const _connected: any = connect(mapStateToProps, mapDispatchToProps)(Rooms);
export default _connected;
